<template lang="pug">
v-flex 
  v-card
    v-card-title Usuarios
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar Usuario' single-line hide-details)
      v-dialog(v-model='Users.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-form(autocomplete='false')
              v-container(grid-list-md)
                v-layout(wrap)
                  v-flex(xs12)
                    v-autocomplete( v-model='data.privileges' label='Seleccionar permisos' multiple item-text='name' :items="PrivilegesRecord" item-value="routerName")
                  v-flex(xs12)
                    v-autocomplete( v-model='data.customer' label='Seleccionar base de datos' multiple item-text='name' :items="CustomersRecord" item-value="slug")
                  v-flex(xs12 sm6)
                    v-text-field(v-model='data.name' label='Nombre')
                  v-flex(xs12 sm6)
                    v-select(v-model='data.role' :items='userTypeRecord' item-text='name' label='Cargo')
                  v-flex(xs12 sm6)
                    v-text-field(v-model='data.address' label='Dirección')
                  v-flex(xs12 sm6)
                    v-text-field(v-model='data.document' label='DNI')
                  v-flex(xs12 sm6)
                    v-text-field(v-model='data.phone' label='Telefono')
                  v-flex(xs12 sm6)
                    v-text-field(v-model='data.email' label='E-mail')
          v-card-actions
            v-spacer
            v-btn(color='blue darken-1' @click='save()') {{ titleButton }} 
    v-data-table.elevation-1(:headers='headers' :items=' usersRecord' :search='search')
      template(v-slot:item.action='{item}')
        v-btn(color='secondary' icon @click='editItem(item.key)')
          v-icon(small) far fa-edit
        v-btn(color='secondary' icon @click='deleteItem(item.key)')
          v-icon(small) far fa-trash-alt
</template>
<script>
import { mapGetters, mapActions, mapMutations,mapState } from 'vuex'
export default {
  data: () => ({
    search: '',
    model: '',
    value:'',
    search: null,
    headers: [
      { text: 'Lista de Usuarios',align: 'left',value: 'name'},
      { text: 'Cargos', value: 'role' },
      { text: 'Direccion', value: 'address' },
      { text: 'Dni', value: 'document' },
      { text: 'Telefono', value: 'phone' },
      { text: 'E-mail', value: 'email' },
      { text: 'Fecha de creación', value: 'createdAt' },
      { text: '', value: 'action', sortable: false }
    ],
  }),
    methods: {
      ...mapActions({
        editItem: 'Users/get',
        deleteItem: 'Users/clean',
        save: 'Users/add',
        clearForm: 'Users/clearForm'
      }),
    },
    computed: {
      title(){ return this.Users.selectedKey == '' ? 'Registar' : 'Crear' },
      titleButton() { return this.Users.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        usersRecord: 'Users/record',
        userTypeRecord: 'UserType/recordTypeRole',
        PrivilegesRecord: 'Privileges/record',
        CustomersRecord: 'Customers/record',
      }),
       ...mapState({
        data: state=> state.Users.data,
        Users :state=> state.Users,
      })
    },
}
</script>
